.button {
  border-radius: var(--border-radius-lg);
  color: var(--colors-grays-black);
  background: var(--colors-grays-ultralight);
  border: 2px solid var(--colors-grays-ultralight);
  cursor: pointer;
  font-weight: 600;
  line-height: 1;
  padding: 16px 24px;
  transition: all 250ms;
  width: 100%;

  &:hover,
  &:active {
    background-color: var(--colors-grays-light);
    border-color: var(--colors-grays-light);
  }
}

.button--selected {
  border-color: var(--colors-primary-main);

  &:hover,
  &:active {
    border-color: var(--colors-primary-main);
  }
}
